export default __webpack_public_path__ + "static/media/left-arrow.cbce28f7.svg";